/* app/js/src/components/scheduler/libraryItem/marker-library-item/marker-library-item.component.scss */
.marker-item {
  display: flex;
  align-items: center;
  width: 348px;
  height: 55px;
  background-color: white;
  cursor: grab;
}
.content-container {
  display: flex;
  flex-direction: row;
  margin-left: 18px;
}
.marker-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
}
.marker-label {
  display: flex;
  align-items: center;
  margin-left: 19px;
  font-size: 12px;
}
/*# sourceMappingURL=marker-library-item.component.css.map */
